import { gql } from '@apollo/client'

export const HOLE_IN_ONE_BY_CLAIM_TOKEN = gql`
  query HoleInOneByClaimToken($claimToken: String!) {
    holeInOneByClaimToken(claimToken: $claimToken) {
      id
      maskedEmail
      golferName
      courseName
      occurredAt
      holeNumber
      holePar
      yardage
      legalAgreementsAcceptedAt
    }
  }
`

export const CLAIM_HOLE_IN_ONE = gql`
  mutation ClaimHoleInOne($input: ClaimHoleInOneInput!) {
    claimHoleInOne(input: $input) {
      success
      message
      token
      holeInOne {
        id
        golferName
        maskedEmail
      }
    }
  }
`
